module.exports = __webpack_public_path__ + "8a838fe470b792f2d696fe96b59a08aa.pdf";